import { useContext } from 'react';

import { GlobalContext } from '../context/GlobalContext';
// eslint-disable-next-line import/no-cycle
import { UserDataContext } from '../context/UserDataContext';

export const useGlobalContext = () => useContext(GlobalContext);
export const useUserDataContext = () => useContext(UserDataContext);
export const useLoggerContext = () => {
  const { userDetails, targetUser } = useGlobalContext();

  return {
    login: userDetails.login,
    employeeId: userDetails.employeeId,
    warehouseId: userDetails.warehouseId,
    isAdmin: userDetails.isAdmin,
    locale: userDetails.locale,
    targetUserLogin: targetUser.login,
    targetUserEmployeeId: targetUser.employeeId,
  };
};
